import { extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { noop } from '../../../../utils/noop.js';
import { useConfirmAction } from '../../../../hooks/useConfirmAction.js';
import { i18n } from '../../../../i18n/translate.js';
import { ActionButton } from '../ActionButton/component.js';

var DeleteActionButton = function DeleteActionButton(props) {
  var _props$action = props.action,
      action = _props$action === void 0 ? noop : _props$action,
      actionType = props.actionType,
      confirmChildren = props.confirmChildren,
      confirmTitle = props.confirmTitle,
      deleteMember = props.deleteMember,
      _props$row = props.row,
      row = _props$row === void 0 ? {} : _props$row;

  var _useConfirmAction = useConfirmAction({
    action: deleteMember ? function () {
      deleteMember(row);
    } : action,
    children: confirmChildren,
    disabled: actionType !== 'confirm',
    title: confirmTitle
  }),
      confirmAction = _useConfirmAction.action,
      confirmationModal = _useConfirmAction.confirmationModal;

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ActionButton, _extends({
    icon: "trash",
    title: i18n.t('delete'),
    tooltip: i18n.t('Delete')
  }, props, {
    actionType: "callToAction",
    action: confirmAction
  })), confirmationModal);
};

export { DeleteActionButton };